module.exports = __webpack_public_path__ + "static/media/yes-do-not-agree.a094da9b.svg";